/*
 * @Descripttion: file content
 * @Author: zc
 * @Date: 2020-05-26 13:24:22
 * @LastEditors: zc
 * @LastEditTime: 2022-09-20 10:50:00
 */
import { service, formService } from '@/data/index';
import { emesBaseUrl } from '@/config';
/*
 * 获取验证码
 */

export function getImgCaptcha() {
  return service.get('/captcha/getCaptcha');
}
/*
 * 验证码验证
 */

export function validateCaptcha(data) {
  return service.get('/captcha/validate', data);
}
/*
 * 切换机构
 */

export function changeOrgRole(data) {
  return formService.post('/changeOrgRole', data);
}
/*
 * 获取登录用户角色机构集
 */

export function getOrgRoleList(data) {
  return service.get('/getOrgRoleList', data);
}
/*
 * 以何种身份登录
 */

export function loginByRole(data) {
  return formService.post('/changeOrgRole', data);
} // 设置学制

export function saveSchoolSystem(data) {
  return service.get('school/school/saveSchoolSystem', data);
}
/*
 * 腾讯端登录
 */

export function getWxLogin(data) {
  return formService.post('tencent/login/pc', data);
}
/*
 * 电信接入登录链接
 */

export function getAuthorizeUrl(data) {
  return formService.get('oauth/authorizeUrl', data);
}
/*
 * 电信接入登录
 */

export function authLogin(data) {
  return formService.post('oauth/login', data);
}
/*
 * 80中接入登录
 */

export function loginpl(data) {
  return formService.get('login-lp', data);
}
/*
 * 登录
 */

export function login(data) {
  return formService.post('login', data);
}
/*
 * 发送短信验证码
 */

export function sendCode(data) {
  return formService.post('sendCode', data);
}
export function sendCodeDirect(data) {
  return formService.post('sendCodeDirect', data);
}
/*
 * 验证短信验证码
 */

export function retrievePassword(data) {
  return formService.post('retrievePassword', data);
}
/*
 * 密码修改
 */

export function updatePassword(data) {
  return service.post('updatePassword', data);
}
/*
 * 验证身份信息是否正确
 */

export function recoveryIdentity(data) {
  return service.get('recoveryIdentity', data);
}
export function checkUserNameRight(data) {
  return service.get('checkUserNameRight', data);
}
/*
 * 身份验证重置密码
 */

export function updatePasswordForIdentity(data) {
  return service.post('updatePasswordForIdentity', data);
}
/*
 * 验证账号是否存在
 */

export function checkUserExist(data) {
  return service.get('checkUserExist', data);
}
/*
 * 通过登录机构获取已授权应用
 */

export function getAppByOrgCode(data) {
  return service.get('admin/app', data);
}
/**
 * 获取单位信息
 * @param data
 */

export function getLoginUser() {
  return service.get('getLoginUser');
}
/**
 * 单位信息切换接口
 * @param data
 */

export function resetLoginOrg(data) {
  return service.get('app/resetLoginOrg', data);
}
/*
 * 获取学生/教师列表
 */

export function getCommonUser(data) {
  return service.get('school/student/getCommonUser', data);
} // 授权操作

export function grantTrialHandle(data) {
  // return service.post('evaluation/grantTrial',data);
  return formService({
    baseURL: emesBaseUrl,
    url: 'evaluation/grantTrial',
    method: 'post',
    data: data
  });
}
/*
 * 重置学生密码
 */

export function resetStuPassword(data) {
  return service.post('school/student/updatePassword', data);
}
/*
 * 重置教师密码
 */

export function resetTeaPassword(data) {
  return service.post('school/teacher/updatePasswordJson', data);
}
/*
 * 根据年级获取班级列表
 */

export function getClassListByGrade(data, paramsUrl) {
  // return service.post('evaluation/getClassListByGrade/'+paramsUrl,data);
  return service({
    baseURL: emesBaseUrl,
    url: 'evaluation/getClassListForBms/' + paramsUrl,
    method: 'get',
    params: data
  });
}
/*
 * 获取临时学籍号
 */

export function getAutoSid(data) {
  return service.get('school/student/getAutoSid', data);
}
/*
 * 新增学生确认
 */

export function addNewStudent(data) {
  return service.post('school/student/addNew', data);
}